import { Box, Grid, Paper } from '@mui/material';
import { useEffect } from 'react';
import { LeasesMenuList, LeasesNav } from '../../../elements';
import Lessor from '../components/lessor';
import Lessee from '../components/lessee';
import BillableAssemblies from '../components/billableAssemblies';
import LeaseAttachments from '../components/leaseAttachments';
import LeaseInformation from '../components/leaseInformation';
import { Link, useParams } from 'react-router';
import LeasesBasicDetails from '../../../elements/LeasesBasicDetails';
import { RoleBaseAccess } from '../../../../hoc';
import { trackActivity } from '../../../../utils/mixpanel';
import { useDispatch, useSelector } from 'react-redux';
import ModuleNotExcessModal from '../../../../shared_elements/components/ModuleNotExcessModal';
import { getStorage } from '../../../../shared_elements/actionCreators';
import CapeTownConvention from '../components/capeTownConvention';
import EngineRightView from '../components/EngineRightView';
import { PermissionWrapper } from '../../../../wrappers';
import BackToLeaseList from '../../../elements/BackToLeaseList';

const Headlines = () => {
  const { leaseSlug } = useParams();
  const params = { leaseSlug: leaseSlug }
  const dispatch = useDispatch()
  const { leaseBasicDetails, permission } = useSelector((state) => state.leases);
  const headlinesPermission = permission?.permissions?.lease_revamp_application?.lease_revamp?.headlines || false;
  const hasHeadlinesReadPermission = headlinesPermission && headlinesPermission?.includes('R');
  const leaseAssetType = Number(leaseBasicDetails?.asset?.asset_type ?? leaseBasicDetails?.asset_type);


  useEffect(() => {
    trackActivity('Page Viewed', { page_title: 'Headlines' })
    dispatch(getStorage({ lease_slug: params?.leaseSlug, module_name: "lease" }))
  }, [])

  return (
    <>
      <LeasesBasicDetails />
      <Paper className='lease-details-section section-overflow lease-module-paper' elevation={0}>
        <LeasesNav type="basic" />
        {leaseBasicDetails && Object.keys(leaseBasicDetails).length > 0 && !leaseBasicDetails?.status ? (<ModuleNotExcessModal leaseNotFound />) :
          !hasHeadlinesReadPermission ? (
            <div className='lease-details-content' style={{ minHeight: 'calc(100vh - 220px)', width: '80vw', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <div style={{
                color: '#000000',
                textAlign: 'center', margin: '0 auto'
              }}>
                <br /><br />
                  Sorry, You do not have access to this page.<br />
                  Please contact Acumen for access.<br />
                <Link to="/leases"> Go Back</Link>
              </div>
            </div>
          ) :
            <div className='lease-details-content'>
              <Paper square className="responsive-paper">
                <Grid container className="responsive-grid" spacing={1} alignItems='end'>
                  <Grid item size={{ md: 12, xs: 12 }} className="menu-container">
                    <LeasesMenuList btnText="Headlines" type="basic" />
                  </Grid>
                  <Grid item size={{ md: 8, xs: 12 }}>
                    <BackToLeaseList />
                  </Grid>
                </Grid>
              </Paper>
              <Box className='headline-detail-container'>
                <Grid container spacing={1}>
                  <Grid size={{ xs: 12, md: 9 }}>
                    <Grid container spacing={1} alignItems="stretch">
                      <Grid size={{ xs: 12, md: 6 }} sx={{ display: 'flex' }}>
                        <Lessor />
                      </Grid>
                      <Grid size={{ xs: 12, md: 6 }} sx={{ display: 'flex' }}>
                        <Lessee />
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid size={{ xs: 12, md: 3 }} >
                    <BillableAssemblies />
                    <LeaseAttachments />
                  </Grid>
                </Grid>
                <Grid container >
                  <Grid size={{ xs: 12, md: 12 }}>
                    <LeaseInformation />
                  </Grid>

                  {![3, 4, 5].includes(leaseAssetType) ? (
                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "engine_rights", operationType: ['R'] }}>
                      <Grid size={{ xs: 12, md: 12 }}>
                        <EngineRightView />
                      </Grid>
                    </PermissionWrapper>
                  ) : null}
                </Grid>
              </Box>
            </div>}
      </Paper>
    </>
  )
}

export default RoleBaseAccess(Headlines, { application: 'lease_revamp', feature: 'lease_details', operationType: ['R'], leaseNav: true });
